import { render, staticRenderFns } from "./ArticlesReport.vue?vue&type=template&id=0e26c81b&"
import script from "./ArticlesReport.vue?vue&type=script&lang=js&"
export * from "./ArticlesReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports